import Header from "../components/Header";
import HeroSection from "../components/Hero";
import AboutUs from "../components/AboutUs";
import CompanyIntroduction from "../components/CompanyIntroduction";
import TypicalAchievements from "../components/TypicalAchievements";
import PartnerSection from "../components/PartnerSection";
import ContactSection from "../components/Contact";

function HomePage() {
  return (
    <div className="App">
      <Header />
      <section id="home">
        <HeroSection />
      </section>
      <section id="about">
        <AboutUs />
      </section>
      <section id="company-introduction">
        <CompanyIntroduction />
      </section>
      <section id="achievements">
        <TypicalAchievements />
      </section>
      <section id="partner">
        <PartnerSection />
      </section>
      <section id="contact">
        <ContactSection />
      </section>
    </div>
  );
}

export default HomePage;